import { useCallback } from 'react';

import {
  useListHubspotContacts,
  useListHubspotCompanies,
  useCreateHubspotEngagement,
  CrmEventDto,
  CreateHubspotEngagementMutationResult
} from '@/api/generated';

export default function useHubspotEngagements() {
  const {
    data: hubspotContacts,
    isLoading: isLoadingHubspotContacts,
    isError: isErrorHubspotContacts,
    refetch: refetchHubspotContacts
  } = useListHubspotContacts();
  const {
    data: hubspotCompanies,
    isLoading: isLoadingHubspotCompanies,
    isError: isErrorHubspotCompanies,
    refetch: refetchHubspotCompanies
  } = useListHubspotCompanies();

  const { mutateAsync: mutateCreateEngagement } = useCreateHubspotEngagement();

  const createHubspotEngagement = useCallback(
    async (engagement: CrmEventDto): Promise<CreateHubspotEngagementMutationResult> => {
      const response = await mutateCreateEngagement({ data: engagement });
      return response;
    },
    [mutateCreateEngagement]
  );

  return {
    hubspotContacts,
    hubspotCompanies,
    isLoadingHubspotContacts,
    isLoadingHubspotCompanies,
    isErrorHubspotContacts,
    isErrorHubspotCompanies,
    refetchHubspotContacts,
    refetchHubspotCompanies,
    createHubspotEngagement
  };
}
